import { useState } from 'react'
import {
	EuiModal,
	EuiModalHeader,
	EuiModalHeaderTitle,
} from '@equipmentshare/ds2'
import ReceiveParts from '../ReceiveParts'
import ProcessingStatusPopover from '../ProcessingStatusPopover'
import { Transaction } from '../../../../../../graphql'

export type ProcessingStatusProps = {
  label: string,
  transaction: Transaction,
}

export default function ProcessingStatus( { label, transaction }: ProcessingStatusProps ) {
	const [ isFormOpen, setIsFormOpen ] = useState( false )

	const openForm = () => setIsFormOpen( true )
	const closeForm = () => setIsFormOpen( false )

	return (
		<div>
			<ProcessingStatusPopover
				label={label}
				openForm={openForm}
				transaction={transaction}
			/>
			{ isFormOpen && (
				<EuiModal onClose={closeForm}>
					<EuiModalHeader>
						<EuiModalHeaderTitle>
							Items Received
						</EuiModalHeaderTitle>
					</EuiModalHeader>

					<ReceiveParts
						closeForm={closeForm}
						transaction={transaction}
					/>
				</EuiModal>
			) }
		</div>
	)
}
